"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parserPrimitiveExpression = void 0;
const util_1 = require("../util");
const parserPrimitiveExpression = (BaseClass) => {
    const DerivedClass = class extends BaseClass {
        visitNumberExpression(ctx) {
            return {
                type: 'Literal',
                valueType: 'int',
                value: parseInt(ctx.text),
                loc: (0, util_1.contextToLocation)(ctx)
            };
        }
        visitFloatExpression(ctx) {
            return {
                type: 'Literal',
                valueType: 'float',
                value: parseFloat(ctx.text),
                loc: (0, util_1.contextToLocation)(ctx)
            };
        }
        visitCharExpression(ctx) {
            return {
                type: 'Literal',
                valueType: 'char',
                value: ctx.text.trim().charAt(1),
                loc: (0, util_1.contextToLocation)(ctx)
            };
        }
    };
    return DerivedClass;
};
exports.parserPrimitiveExpression = parserPrimitiveExpression;
//# sourceMappingURL=primitiveParser.js.map